import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  REGISTER_USER_RESET,
  REGISTER_USER_RESEND,
  REGISTER_USER_API_ERROR,
  FETCH_COUNTRY,
  RESET_REGISTER_RESPONSE_MSG,
  SET_COUNTRY_LIST,
  FETCH_COUNTRY_LIST,
  FETCH_COUNTRY_AND_STATES_LIST,
  SET_COUNTRY_AND_STATES_LIST
} from "./actionTypes"

const initialState = {
  registrationError: false,
  registrationErrorMessage: null,
  message: null,
  loading: false,
  user: null,
  linkSend: false,
  apiError: false,
  hello: false,
  country: {
    loading: false,
    list: []
  },
  countryAndStates: {
    loading: false,
    list: []
  }
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER:
      state = {
        ...state,
        loading: true,
        apiError: false,
        linkSend: false,
      }
      break
    case REGISTER_USER_SUCCESSFUL:
      console.log('success', action.payload)
      state = {
        ...state,
        loading: false,
        user: action.payload.response.email,
        pswdforLogin: action.payload?.userpwd ? action.payload?.userpwd : state.pswdforLogin,
        emailforLogin: action.payload?.response?.email,
        registrationErrorMessage: action.payload.responseMessage,
        registrationError: false,
        linkSend: true,
        plan_id: action.payload?.plan_id,
        userpwd: action.payload?.userpwd,
        from: action.payload.from ? action.payload.from : state.from
      }
      break
    case REGISTER_USER_FAILED:
      console.log('failed', action.payload)
      state = {
        ...state,
        user: null,
        loading: false,
        registrationError: true,
        registrationErrorMessage: action.payload,
      }
      break
    case REGISTER_USER_RESEND:
      state = {
        ...state,
        loading: true,
      }
      break
    case REGISTER_USER_RESET:
      state = {
        registrationError: false,
        registrationErrorMessage: null,
        message: null,
        loading: false,
        user: null,
        linkSend: false,
        apiError: false,
        country: {
          list: [],
          loading: false
        },
        countryAndStates: {
          loading: false,
          list: []
        },
      }
      break
    case FETCH_COUNTRY_LIST:
      state = {
        ...state,
        country: {
          list: [],
          loading: true
        }
      }
      break
    case REGISTER_USER_API_ERROR:
      state = {
        ...state,
        loading: false,
        apiError: true,
      }
    case RESET_REGISTER_RESPONSE_MSG:
      state = {
        ...state,
        loading: false,
        registrationError: false,
        registrationErrorMessage: null,
      }
      break
    case SET_COUNTRY_LIST:
      state = {
        ...state,
        country: {
          list: action.payload.list,
          loading: action.payload.loading
        }
      }
      break
    case FETCH_COUNTRY_AND_STATES_LIST:
      state = {
        ...state,
        countryAndStates: {
          list: [],
          loading: true
        }
      }
      break
    case SET_COUNTRY_AND_STATES_LIST:
      state = {
        ...state,
        countryAndStates: {
          list: action.payload.list,
          loading: action.payload.loading
        }
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default account
